import { NameDto } from 'api/Common/Types'

export interface AffiliateDto {
  id: string
  username: string
  externalId: string
  firstname: string
  lastname: string
  email: string
  street: string
  country: NameDto<string>
  state: string
  city: string
  zipCode: string
  phoneNumber: string
  phoneCountryCode?: string
  website: string
  companyName: string
  affiliateType: NameDto
  status: NameDto
  source: NameDto
  referredClientRangeType: NameDto | null
  operationCountries: NameDto[]
  socialMediaPlatforms: NameDto[]
  promotionMediaPlatforms: NameDto[]
  birthday: string
  nationality: NameDto<string>
  createdDate: string
}

export enum AffiliateOverviewKey {
  affiliateCode = 'externalId',
  fullName = 'fullName',
  birthday = 'birthday',
  country = 'country.name',
  type = 'affiliateType.name',
  email = 'email',
  phoneNumber = 'phoneNumber',

  dateCreated = 'createdDate',
}

export enum AffiliateClientOverviewKey {
  name = 'name',
  country = 'countryName.name',
  assignedAt = 'assignedAt',
}
